import type { NsDict } from '../ru';

export const auth: NsDict<'auth'> = {
  lead: 'Forecast the move of a hidden index of three S&P 500 stocks. First only the chart, then the scale, and only in the last round the composition.',
  point1b: '4–8 players',
  point1: 'per table, three one-minute betting rounds',
  point2b: 'Verifiable settlement:',
  point2: 'a signed package with quotes and ledger entries',
  point3b: 'History and statistics',
  point3: 'of all your games in your profile',
  demo: 'Demo: {amount|cr} of play credits are granted on sign-up. No real money.',
  tabLogin: 'Sign in',
  tabRegister: 'Sign up',
  login: 'Username',
  loginPh: 'Latin letters, digits, . _ -',
  name: 'Table name',
  namePh: 'e.g. Irina',
  password: 'Password',
  passwordHint: 'at least 8 characters, letters and digits',
  password2: 'Repeat password',
  mismatch: 'passwords do not match',
  submitLogin: 'Sign in',
  submitRegister: 'Sign up',
  or: 'or with',
  created: 'Account created. You can change your table name in your profile.',
  linked: '{provider}: account linked to your profile',
  failed: 'sign-in failed',
  'provider.yandex': 'Yandex',
  'mark.yandex': 'Y',
};
